import _ from 'lodash'
import { Map, List, fromJS } from 'immutable'
import { DEVICE_DEFAULT_MAX_SIZE } from './DEVICE_DEFAULT_MAX_SIZE'
import { getValueForModeJS } from '../constants/toUnits'
import { TAB_TYPES } from './tab-utils'
import { getUID } from './guid'
import { fixID } from './common'
import { getPersistentDrawerWidth } from './processPortalRules'

const orderChildrenByPosition = (elements, children, mode) => {
  if (!children) {
    return []
  }
  let order = {}
  _.each(children, function (uid) {
    if (uid && elements[uid]) {
      let top, left
      if (_.get(elements, [uid, 'props', mode, 'position', 'top'], 0)) {
        top = parseInt(_.get(elements, [uid, 'props', mode, 'position', 'top'], 0))
      }
      if (_.get(elements, [uid, 'props', mode, 'position', 'left'], 0)) {
        left = parseInt(_.get(elements, [uid, 'props', mode, 'position', 'left'], 0))
      }
      if (isNaN(top)) {
        top = 0
      }
      if (isNaN(left)) {
        left = 0
      }
      if (!order[top]) {
        order[top] = []
      }
      order[top].push({
        left: left,
        uid: uid,
      })
    }
  })
  let ordered = _.sortBy(order, function (row, top) {
    return parseInt(top)
  })
  let result = []
  _.each(ordered, function (row) {
    row = _.sortBy(row, function (elem) {
      return elem.left
    })
    _.each(row, function (elem) {
      result.push(elem.uid)
    })
  })
  return result
}

const getDefaultStyle = (state, mode, nodeStyle, paddingStyles = { paddingTop: 20, paddingBottom: 20 }) => {
  let isBuilder = state.get('isWebBuilder', false)
  let IsConfiguredDevice = {}
  let modes = ['sml', 'sm', 'xs', 'ss']
  if (isBuilder) {
    modes = [mode]
  }
  _.each(modes, function (row) {
    IsConfiguredDevice[row] = true
  })
  if (!nodeStyle) {
    return {
      lg: {
        root: {
          width: '100',
          widthUnit: '%',
          height: 'auto',
          border: 0,
          minWidth: '',
          minWidthUnit: 'px',
        },
      },
      type: 'Stack',
      IsConfiguredDevice: IsConfiguredDevice,
      [mode]: {
        root: Object.assign(
          {
            width: '100',
            widthUnit: '%',
            height: 'auto',
            border: 0,
            minWidth: '',
            minWidthUnit: 'px',
          },
          paddingStyles
        ),
      },
      sml: {
        root: Object.assign(
          {
            width: '100',
            widthUnit: '%',
            maxWidth: '100',
            maxWidthUnit: '%',
            height: 'auto',
            border: 0,
            paddingTop: 20,
            paddingTopUnit: 'px',
            paddingBottom: 20,
            paddingBottomUnit: 'px',
            gridGap: '20',
            paddingLeft: 20,
            paddingRight: 20,
          },
          paddingStyles
        ),
      },
      sm: {
        root: Object.assign(
          {
            width: '100',
            widthUnit: '%',
            maxWidth: '100',
            maxWidthUnit: '%',
            height: 'auto',
            border: 0,
            paddingTop: 20,
            paddingTopUnit: 'px',
            paddingBottom: 20,
            paddingBottomUnit: 'px',
            gridGap: '20',
            paddingLeft: 20,
            paddingRight: 20,
          },
          paddingStyles
        ),
      },
      xs: {
        root: Object.assign(
          {
            width: '100',
            widthUnit: '%',
            maxWidth: '100',
            maxWidthUnit: '%',
            height: 'auto',
            border: 0,
            paddingTop: 20,
            paddingTopUnit: 'px',
            paddingBottom: 20,
            paddingBottomUnit: 'px',
            gridGap: '20',
            paddingLeft: 20,
            paddingRight: 20,
          },
          paddingStyles
        ),
      },
      ss: {
        root: Object.assign(
          {
            width: '100',
            widthUnit: '%',
            maxWidth: '100',
            maxWidthUnit: '%',
            height: 'auto',
            border: 0,
            paddingTop: 20,
            paddingTopUnit: 'px',
            paddingBottom: 20,
            paddingBottomUnit: 'px',
            gridGap: '20',
            paddingLeft: 20,
            paddingRight: 20,
          },
          paddingStyles
        ),
      },
      isHidden: {},
    }
  }

  nodeStyle[mode] = {
    root: Object.assign(
      {
        minWidth: '',
        minWidthUnit: 'px',
        width: '100',
        widthUnit: '%',
        maxWidth: '100',
        maxWidthUnit: '%',
        height: 'auto',
        border: 0,
        paddingTop: 20,
        paddingTopUnit: 'px',
        paddingBottom: 20,
        paddingBottomUnit: 'px',
        gridGap: '20',
        paddingLeft: 20,
        paddingRight: 20,
      },
      paddingStyles
    ),
  }

  return nodeStyle
}
const getDefaultStack = (element, parent, area, uid, children, mode, isBuilder, state, stripStyle, stripElem) => {
  if (!element) {
    element = {
      type: 'Stack',
      props: {
        lg: {
          direction: 'row',
          gridArea: 'none',
          position: {
            left: 0,
            top: 0,
          },
          isHidden: false,
        },
        styleRef: uid,
      },
      children: children,
      parent: parent,
    }
  } else {
    element.children = children
  }
  let modes = ['sml', 'sm', 'xs', 'ss']
  _.each(modes, function (lMode) {
    let localArea = area
    if (isBuilder && mode != lMode) {
      let page = state.getIn(['page'])
      if (
        (state.getIn(['pages', page, 'Props', 'IsConfiguredDevice', lMode], false) &&
          !state.getIn(['pages', page, 'Props', 'isConfiguredAutoFit', lMode], false)) ||
        (!state.getIn(['pages', page, 'Props', 'IsConfiguredDevice', lMode], false) &&
          !state.getIn(['pages', page, 'Props', 'isConfiguredAutoFit', lMode], false))
      ) {
        localArea = 'none'
      }
    }
    if (!isBuilder) {
      if (stripStyle && mode != lMode) {
        if (
          _.get(stripStyle, ['IsConfiguredDevice', lMode]) &&
          !_.get(stripElem, ['props', lMode, 'isConfiguredAutoFit'])
        ) {
          localArea = 'none'
        }
      }
    }
    element.props[lMode] = {
      direction: 'row',
      gridArea: localArea,
      position: {
        left: 0,
        top: 0,
      },
      isHidden: false,
    }
  })

  return element
}

export const moveElementsToAutoFit = (state, processType) => {
  const mode = state.getIn(['layoutMode'], 'lg')
  const uidGen = getUID(state)
  let pageID = state.get('page')
  if (!state.get('versionForRecalculate')) {
    if (state.getIn(['project', 'Settings', 'responsiveAIConf', 'version']) != 2) {
      if (processType == 'page') {
        console.log('render version 1')
      }
      return state
    }
  }
  if (processType == 'page') {
    console.log('render version 2')
  }

  if (state.get('isWebBuilder')) {
    if (!state.get('versionForRecalculate')) {
      return state
    }
  }
  if (state.get('versionForRecalculate') == 'v1') {
    return state.set('versionForRecalculate', '')
  } else if (mode == 'lg' || mode == 'md') {
    return state
  }

  if (!state.get('isWebBuilder')) {
    if (processType != 'project') {
      if (state.getIn(['pages', pageID, 'Props', 'IsConfiguredDevice', mode], false)) {
        return state
      }
    }
  }

  let isRTL = false
  let projectDirection = state.getIn(['project', 'Settings', 'isRTL'], false)

  let pageDirection = state
    .getIn(['project', 'Pages'], List())
    .find((page) => page.get('_id') === pageID)
    ?.get?.('direction', '')
  if (pageDirection) {
    isRTL = pageDirection === 'ltr' ? false : pageDirection === 'rtl' ? true : false
  } else {
    isRTL = projectDirection
  }

  const pcDesktopRoot = parseInt(state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', 'root', 'width'], '1367'))
  const pcDesktopRootUnit = state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', 'root', 'widthUnit'], 'px')
  let pageWidth = parseInt(state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', state.get('page'), 'width']))
  let pageWidthUnit = state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', state.get('page'), 'widthUnit'])
  if (!pageWidth || isNaN(pageWidth)) {
    pageWidth = pcDesktopRoot
    pageWidthUnit = pcDesktopRootUnit
  }
  try {
    let staticSizeTypes = ['Widget', 'Image', 'YouTube', 'Vimeo', 'iframe']
    let maxDeviceSize = DEVICE_DEFAULT_MAX_SIZE[mode]

    let page = state.getIn(['page'])
    let grid, elements, styles
    if (processType == 'project') {
      grid = ['Footer', 'Header']
      state.getIn(['project', 'Settings', 'ui', 'Modal'], List()).map((id) => {
        grid.push(id)
      })
      elements = state.getIn(['project', 'Settings', 'elements'], Map()).toJS()
      styles = state.getIn(['project', 'Settings', 'styles'], Map()).toJS()
    } else {
      grid = state.getIn(['pages', page, 'Props', 'Grid'], List()).toJS()
      elements = state.getIn(['pages', page, 'Props', 'elements'], Map()).toJS()
      styles = state.getIn(['pages', page, 'Props', 'styles'], Map()).toJS()
    }

    const typographyTheme = state.getIn(['project', 'Settings', 'theme', 'lg', 'Typography'], Map()).toJS()

    const setGoodSize = (child, childStyle, parentType, childUID) => {
      let maxWidth = '100',
        maxWidthUnit = '%'
      if (staticSizeTypes.indexOf(child.type) > -1) {
        let width = parseInt(_.get(childStyle, ['lg', 'root', 'width']))
        let widthUnit = _.get(childStyle, ['lg', 'root', 'widthUnit'])
        if (widthUnit == '%' && width && !isNaN(width) && pageWidth && pageWidthUnit == 'px') {
          width = pageWidth * (width / 100)
          widthUnit = 'px'
        }
        if (width && !isNaN(width) && (!widthUnit || widthUnit == 'px')) {
          maxWidth = maxDeviceSize
          maxWidthUnit = 'px'
          if (child.type == 'Image') {
            if (width < maxWidth) {
              maxWidth = width
            }
          }
          let height = parseInt(_.get(childStyle, ['lg', 'root', 'height']))
          let heightUnit = _.get(childStyle, ['lg', 'root', 'heightUnit'])
          if (height && !isNaN(height) && (!heightUnit || heightUnit == 'px')) {
            let rate = maxWidth / width
            height = parseInt(height * rate)
            _.set(childStyle, [mode, 'root', 'minHeight'], '')
            _.set(childStyle, [mode, 'root', 'minHeightUnit'], '')
            _.set(childStyle, [mode, 'root', 'height'], height)
            _.set(childStyle, [mode, 'root', 'width'], maxWidth)
            if (_.get(childStyle, [mode, 'rootHover', 'height']) || _.get(childStyle, [mode, 'rootHover', 'width'])) {
              _.set(childStyle, [mode, 'rootHover', 'height'], '')
              _.set(childStyle, [mode, 'rootHover', 'width'], '')
            }
            if (_.get(childStyle, [mode, 'rootActive', 'height']) || _.get(childStyle, [mode, 'rootActive', 'width'])) {
              _.set(childStyle, [mode, 'rootActive', 'height'], '')
              _.set(childStyle, [mode, 'rootActive', 'width'], '')
            }
            _.set(childStyle, [mode, 'root', 'widthUnit'], maxWidthUnit)
          }
        } else if (child.type == 'Image') {
          maxWidth = maxDeviceSize
          maxWidthUnit = 'px'

          _.set(childStyle, [mode, 'root', 'minHeight'], '')
          _.set(childStyle, [mode, 'root', 'minHeightUnit'], '')
          _.set(childStyle, [mode, 'root', 'height'], 'auto')
          _.set(childStyle, [mode, 'root', 'heightUnit'], '')

          _.set(childStyle, [mode, 'root', 'width'], maxWidth)
          _.set(childStyle, [mode, 'root', 'widthUnit'], maxWidthUnit)

          if (_.get(childStyle, [mode, 'rootHover', 'height']) || _.get(childStyle, [mode, 'rootHover', 'width'])) {
            _.set(childStyle, [mode, 'rootHover', 'height'], '')
            _.set(childStyle, [mode, 'rootHover', 'width'], '')
          }
          if (_.get(childStyle, [mode, 'rootActive', 'height']) || _.get(childStyle, [mode, 'rootActive', 'width'])) {
            _.set(childStyle, [mode, 'rootActive', 'height'], '')
            _.set(childStyle, [mode, 'rootActive', 'width'], '')
          }
        }
      }
      if (child.children && child.children.length && child.type !== 'Modal') {
        _.set(childStyle, [mode, 'root', 'width'], maxDeviceSize)
        _.set(childStyle, [mode, 'root', 'widthUnit'], 'px')

        if (_.get(childStyle, [mode, 'rootHover', 'height']) || _.get(childStyle, [mode, 'rootHover', 'width'])) {
          _.set(childStyle, [mode, 'rootHover', 'height'], '')
          _.set(childStyle, [mode, 'rootHover', 'width'], '')
        }
        if (_.get(childStyle, [mode, 'rootActive', 'height']) || _.get(childStyle, [mode, 'rootActive', 'width'])) {
          _.set(childStyle, [mode, 'rootActive', 'height'], '')
          _.set(childStyle, [mode, 'rootActive', 'width'], '')
        }
      }
      _.set(childStyle, [mode, 'root', 'maxWidth'], '100')
      _.set(childStyle, [mode, 'root', 'maxWidthUnit'], '%')
      _.set(childStyle, [mode, 'root', 'minWidth'], '')
      _.set(childStyle, [mode, 'root', 'minWidthUnit'], '')
      _.set(child, ['props', mode, 'isConfiguredAutoFit'], true)
      _.set(childStyle, ['IsConfiguredDevice', mode], true)

      if (
        staticSizeTypes.indexOf(child.type) > -1 ||
        (_.get(child, ['props', 'lg', 'position', 'transform']) && child.type != 'FormField')
      ) {
        _.set(childStyle, [mode, 'root', 'justifySelf'], 'center')
      } else {
        if (isRTL) {
          _.set(childStyle, [mode, 'root', 'justifySelf'], 'right')
        } else {
          _.set(childStyle, [mode, 'root', 'justifySelf'], 'left')
        }
      }
      if (TAB_TYPES.indexOf(child.type) > -1 || (child.type === 'Modal' && child.props?.isExp)) {
        _.set(child, ['props', mode, 'isDisableParentResize'], false)
        _.each(_.get(child, ['props', 'lg', 'tabs']), function (lgTab) {
          if (lgTab) {
            if (!lgTab.uid) {
              lgTab.uid = uidGen.genID('tabid')
            }
            if (lgTab.children) {
              let modes = ['sml', 'sm', 'xs', 'ss']
              if (state.get('isWebBuilder')) {
                modes = [mode]
              }
              let processTab
              _.each(_.get(child, ['props', mode, 'tabs']), function (lTab) {
                if (lTab && !lTab.uid && lTab.id == lgTab.id) {
                  lTab.uid = lgTab.uid
                }
                if (lTab.uid == lgTab.uid) {
                  processTab = lTab
                }
              })
              if (!processTab) {
                return true
              }
              let fitUID = `fit_tab_${childUID}_${processTab.uid}`
              if (processTab.children[0] == fitUID) {
                return true
              }

              let classNameKey = fixID(processTab.id)
              if (child.type == 'TwoSideSection') {
                let minHeight = _.get(childStyle, [mode, 'root', 'height'], '')
                let contentHeight = _.get(childStyle, [mode, 'content', 'height'], '')
                if (contentHeight && contentHeight != 'auto') {
                  minHeight = contentHeight
                }
                childStyle = _.set(childStyle, [mode, 'root', 'height'], 'auto')
                childStyle = _.set(childStyle, [mode, 'root', 'minHeight'], minHeight)
              }
              if (!['ContinualForm', 'CarouselContainer', 'Modal'].includes(child.type)) {
                childStyle = _.set(childStyle, [mode, classNameKey, 'width'], maxDeviceSize)
                childStyle = _.set(childStyle, [mode, classNameKey, 'widthUnit'], 'px')
                childStyle = _.set(childStyle, [mode, classNameKey, 'maxWidth'], '')
                childStyle = _.set(childStyle, [mode, classNameKey, 'minWidth'], '')
                childStyle = _.set(childStyle, [mode, classNameKey, 'height'], 'auto')
                childStyle = _.set(childStyle, [mode, classNameKey, 'maxHeight'], 'auto')
                childStyle = _.set(childStyle, [mode, 'root', 'height'], 'auto')
                childStyle = _.set(childStyle, [mode, 'root', 'maxHeight'], 'auto')
              }

              childStyle = _.set(childStyle, [mode, 'root', 'marginBottom'], '20')
              childStyle = _.set(childStyle, [mode, 'root', 'marginBottomUnit'], 'px')

              if (processTab.children[0] != fitUID) {
                if (!child.children.includes(fitUID)) {
                  child.children.push(fitUID)
                }
                let children = orderChildrenByPosition(elements, processTab.children, mode)
                styles[fitUID] = getDefaultStyle(state, mode, styles[fitUID])
                elements[fitUID] = getDefaultStack(
                  elements[fitUID],
                  childUID,
                  undefined,
                  fitUID,
                  _.flatten(children),
                  mode,
                  state.get('isWebBuilder'),
                  state
                )
              }
              _.each(modes, function (lMode) {
                _.each(_.get(child, ['props', lMode, 'tabs']), function (lTab) {
                  if (lTab && !lTab.uid && lTab.id == processTab.id) {
                    lTab.uid = processTab.uid
                  }
                  if (lTab.uid == processTab.uid) {
                    lTab.children = [fitUID]
                  }
                })
              })
            }
          }
        })
        // console.log('childStyle >>> ', childStyle);
      } else if (child.type == 'Section') {
        if (_.get(childStyle, [mode, 'root', 'height'])) {
          let height = _.get(childStyle, [mode, 'root', 'height'])
          let heightUnit = _.get(childStyle, [mode, 'root', 'heightUnit'])
          _.set(childStyle, [mode, 'root', 'minHeight'], height)
          if (heightUnit) {
            _.set(childStyle, [mode, 'root', 'minHeightUnit'], heightUnit)
          }
          _.set(childStyle, [mode, 'root', 'height'], '')
          _.set(childStyle, [mode, 'root', 'heightUnit'], '')
        }
        _.set(child, ['props', mode, 'isResponsiveAi'], true)
        _.set(child, ['props', mode, 'order'], orderChildrenByPosition(elements, child.children, mode))
      } else if (child.type == 'Form') {
        if (mode == 'sml') {
          _.set(childStyle, ['cols', mode], {})
        }
      }

      if (child.type == 'VerticalCard') {
        if (['sm', 'xs', 'ss'].includes(mode) && !_.get(child, ['props', 'isHorizontalMode'], false)) {
          let width = 50
          let widthUnit = '%'
          _.set(childStyle, [mode, 'headerCol', 'width'], width)
          _.set(childStyle, [mode, 'headerCol', 'widthUnit'], widthUnit)
          _.set(childStyle, [mode, 'dataCol', 'widthUnit'], width)
          _.set(childStyle, [mode, 'dataCol', 'widthUnit'], widthUnit)
        }
      } else if (child.type == 'Widget') {
        if (!_.get(childStyle, [mode, 'root', 'minHeight'], '')) {
          _.set(childStyle, [mode, 'root', 'minHeight'], '300')
          _.set(childStyle, [mode, 'root', 'minHeightUnit'], 'px')
        }
        _.set(childStyle, [mode, 'root', 'width'], '100')
        _.set(childStyle, [mode, 'root', 'widthUnit'], '%')
      }
      if (child.type == 'Section' || child.type == 'Stack') {
        let tmpHeight = _.get(childStyle, ['lg', 'root', 'height'])
        let tmpHeightUnit = _.get(childStyle, ['lg', 'root', 'heightUnit'])
        if (tmpHeight) {
          _.set(childStyle, [mode, 'root', 'height'], '')
          _.set(childStyle, [mode, 'root', 'heightUnit'], '')
          _.set(childStyle, [mode, 'root', 'minHeight'], tmpHeight)
          _.set(childStyle, [mode, 'root', 'minHeightUnit'], tmpHeightUnit)
        }
      }

      if (child.type == 'Stepper') {
        if (_.get(childStyle, [mode, 'content'])) {
          _.set(childStyle, [mode, 'content', 'minWidth'], '')
          _.set(childStyle, [mode, 'content', 'maxWidth'], '100')
          _.set(childStyle, [mode, 'content', 'maxWidthUnit'], '%')
          _.set(childStyle, [mode, 'content', 'width'], '100')
          _.set(childStyle, [mode, 'content', 'widthUnit'], '%')
        }
        _.each(_.get(child, ['props', mode, 'tabs']), function (tab) {
          if (tab && tab.id && _.get(childStyle, [mode, tab.id])) {
            _.set(childStyle, [mode, fixID(tab.id), 'minWidth'], '')
            _.set(childStyle, [mode, fixID(tab.id), 'maxWidth'], '100')
            _.set(childStyle, [mode, fixID(tab.id), 'maxWidthUnit'], '%')
            _.set(childStyle, [mode, fixID(tab.id), 'width'], '100')
            _.set(childStyle, [mode, fixID(tab.id), 'widthUnit'], '%')
          }
        })
      } else if (child.type == 'Typography') {
        const defaultFont = _.get(
          typographyTheme,
          [getValueForModeJS(child, 'lg', ['props'], ['variant'], 'p'), 'fontSize'],
          _.get(typographyTheme, 'root.fontSize', '')
        )
        const defaultLineHeight = _.get(
          typographyTheme,
          [getValueForModeJS(child, 'lg', ['props'], ['variant'], 'p'), 'lineHeight'],
          _.get(typographyTheme, 'root.lineHeight', '')
        )
        let lineHeight = parseInt(_.get(childStyle, ['lg', 'root', 'lineHeight'], defaultLineHeight), 10)
        if (lineHeight && !isNaN(lineHeight) && lineHeight > 16) {
          if (mode == 'sm' || mode == 'sml') {
            lineHeight = lineHeight * 0.8
          } else if (mode == 'xs') {
            lineHeight = lineHeight * 0.7
          } else if (mode == 'ss') {
            lineHeight = lineHeight * 0.6
          }
          _.set(childStyle, [mode, 'root', 'lineHeight'], lineHeight)
        }
        let fontSize = parseInt(_.get(childStyle, ['lg', 'root', 'fontSize'], defaultFont), 10)
        if (fontSize && !isNaN(fontSize) && fontSize > 16) {
          if (mode == 'sm' || mode == 'sml') {
            fontSize = fontSize * 0.8
          } else if (mode == 'xs') {
            fontSize = fontSize * 0.7
          } else if (mode == 'ss') {
            fontSize = fontSize * 0.6
          }
          _.set(childStyle, [mode, 'root', 'fontSize'], fontSize)
        }

        _.set(childStyle, [mode, 'root', 'height'], 'auto')
        _.set(childStyle, [mode, 'root', 'heightUnit'], '')
        _.set(childStyle, [mode, 'root', 'width'], '100')
        _.set(childStyle, [mode, 'root', 'widthUnit'], '%')
        _.set(childStyle, [mode, 'root', 'maxHeight'], '')
        _.set(childStyle, [mode, 'root', 'maxHeightUnit'], '')
        _.set(child, ['props', mode, 'position', 'height'], 'auto')
        _.set(child, ['props', mode, 'position', 'heightUnit'], '')
        _.set(child, ['props', mode, 'position', 'maxHeight'], '')
        _.set(child, ['props', mode, 'position', 'maxHeightUnit'], '')
        _.set(child, ['props', mode, 'position', 'width'], '100')
        _.set(child, ['props', mode, 'position', 'widthUnit'], '%')
      }

      _.set(child, ['props', mode, 'isHidden'], _.get(child, ['props', 'lg', 'isHidden'], false))

      if (parentType == 'Stack') {
        _.set(child, ['props', mode, 'position', 'transform'], 'none')
      } else if (parentType != 'Stack') {
        _.set(child, ['props', mode, 'position', 'left'], '50')
        _.set(child, ['props', mode, 'position', 'leftUnit'], '%')

        if (isRTL) {
          _.set(child, ['props', mode, 'position', 'transform'], 'translateX(50%)')
        } else {
          _.set(child, ['props', mode, 'position', 'transform'], 'translateX(-50%)')
        }
      }
    }
    const recursiveFixWidth = (list) => {
      _.each(list, (childUID) => {
        let child = elements[childUID]
        if (!child) {
          return true
        }

        let childStyleRef = _.get(child, ['props', 'styleRef'])
        if (childStyleRef) {
          let childStyle = _.get(styles, childStyleRef)
          if (childStyle) {
            if (child.children && child.children.length) {
              recursiveFixWidth(child.children)
            }
            if (String(childUID).indexOf('fit') == -1) {
              setGoodSize(child, childStyle, child.type, childUID)
            }
          }
        }
      })
    }
    let isHaveMultipleStrips = false
    let hashStyleRef = {}
    _.each(grid, function (stripID) {
      let elem = elements[stripID]
      if (!elem) {
        return true
      }
      let styleRef = _.get(elem, ['props', 'styleRef'])
      if (hashStyleRef[styleRef]) {
        isHaveMultipleStrips = true
      }
      hashStyleRef[styleRef] = true
    })

    _.each(grid, function (stripID) {
      let elem = elements[stripID]
      if (!elem) {
        return true
      }
      let styleRef = _.get(elem, ['props', 'styleRef'])
      let style = _.get(styles, styleRef)
      if (!style) {
        return true
      }
      if (elem.type === 'Modal' && elem.props.isExp) {
        recursiveFixWidth([stripID])
        return true
      }
      if (isHaveMultipleStrips) {
        if (_.get(elem, ['props', mode, 'isConfiguredAutoFit']) || _.get(elem, ['props', mode])) {
          return true
        }
      } else {
        if (_.get(elem, ['props', mode, 'isConfiguredAutoFit']) || _.get(style, ['IsConfiguredDevice', mode])) {
          return true
        }
      }
      _.set(elem, ['props', mode, 'isConfiguredAutoFit'], true)
      _.set(style, ['IsConfiguredDevice', mode], true)
      _.each(_.get(style, ['lg', 'areas']), (row) => {
        let paddingTop = parseInt(_.get(style, [mode, 'root', '--strip-top-gap'], 20))
        paddingTop = Number.isNaN(paddingTop) ? 20 : paddingTop
        let paddingBottom = parseInt(_.get(style, [mode, 'root', '--strip-bottom-gap'], 20))
        paddingBottom = Number.isNaN(paddingBottom) ? 20 : paddingBottom
        _.each(row, (colID) => {
          let fitChildren = []
          if (!elements[`fit_${stripID}_${colID}`]) {
            if (!elem.children.includes(`fit_${stripID}_${colID}`)) {
              elem.children.push(`fit_${stripID}_${colID}`)
            }
          }
          styles[`fit_${stripID}_${colID}`] = getDefaultStyle(state, mode, styles[`fit_${stripID}_${colID}`], {
            paddingTop,
            paddingBottom,
          })
          elements[`fit_${stripID}_${colID}`] = getDefaultStack(
            elements[`fit_${stripID}_${colID}`],
            stripID,
            colID,
            `fit_${stripID}_${colID}`,
            fitChildren,
            mode,
            state.get('isWebBuilder'),
            state,
            style,
            elem
          )
          if (!elements[`fit_${stripID}_${colID}`].props[mode]) {
            let prop = elements[`fit_${stripID}_${colID}`].props.lg || {}
            elements[`fit_${stripID}_${colID}`].props[mode] = JSON.parse(JSON.stringify(prop))
          }
          elements[`fit_${stripID}_${colID}`].props[mode].gridArea = colID
          let filteredList = []
          _.each(elem.children, (childUID) => {
            let child = elements[childUID]
            if (`fit_${stripID}_${colID}` == childUID) {
              return true
            }
            if (!child) {
              return true
            }
            let childStyleRef = _.get(child, ['props', 'styleRef'])
            if (_.get(child, ['props', 'lg', 'gridArea']) == colID) {
              _.set(child, ['props', mode, 'gridArea'], 'ft_auto_fit')
              filteredList.push({
                uid: childUID,
                top: _.get(child, ['props', mode, 'position', 'top'], 0),
              })
            }

            if (childStyleRef) {
              let childStyle = _.get(styles, childStyleRef)
              if (childStyle) {
                if (String(childUID).indexOf('fit') == -1) {
                  setGoodSize(child, childStyle, 'Stack', childUID)
                }

                if (child.children && child.children.length) {
                  recursiveFixWidth(child.children)
                }
                if (staticSizeTypes.indexOf(child.type) > -1) {
                  _.set(childStyle, [mode, 'root', 'justifySelf'], 'center')
                } else {
                  _.set(childStyle, [mode, 'root', 'justifySelf'], isRTL ? 'right' : 'left')
                }
              }
            }
          })

          filteredList = _.sortBy(filteredList, function (row) {
            return row.top
          })

          _.each(filteredList, function (row) {
            if (elements[row.uid]) {
              fitChildren.push(row.uid)
            }
          })
        })
      })
    })

    let retState = state

    if (processType == 'project') {
      retState = retState.setIn(['project', 'Settings', 'elements'], fromJS(elements))
      retState = retState.setIn(['project', 'Settings', 'styles'], fromJS(styles))
    } else {
      retState = retState.setIn(['pages', page, 'Props', 'elements'], fromJS(elements))
      retState = retState.setIn(['pages', page, 'Props', 'IsConfiguredDevice', mode], true)
      retState = retState.setIn(['pages', page, 'Props', 'isConfiguredAutoFit', mode], true)
      retState = retState.setIn(['pages', page, 'Props', 'styles'], fromJS(styles))
    }
    retState = retState.setIn(['project', 'Settings', 'lastID'], uidGen.lastID)
    if (processType === 'project') {
      retState = retState.set('versionForRecalculate', '')
    }
    return retState
  } catch (err) {
    console.error(err)
  }
  state = state.setIn(['project', 'Settings', 'lastID'], uidGen.lastID)
  if (processType === 'project') {
    return state.set('versionForRecalculate', '')
  } else {
    return state
  }
}
